import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { appRoutes } from './app.routes';
import { MessageService } from 'primeng/api';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { GlobalInterceptor } from './core/interceptors/http.interceptors';
import { jwtInterceptor } from './core/interceptors/jwt.interceptors';
import { loadingInterceptor } from './core/interceptors/load.interceptors';

export const appConfig: ApplicationConfig = {
  providers: [

    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      }),
      withEnabledBlockingInitialNavigation()
    ),

    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),

    providePrimeNG({
      theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } }
    }),

    MessageService,

    provideHttpClient(
      withInterceptors([
        jwtInterceptor,
        loadingInterceptor
      ])
    )
  ]
};
